import { render, staticRenderFns } from "./BugReportDialogue.vue?vue&type=template&id=d2ec68c8&scoped=true&"
import script from "./BugReportDialogue.vue?vue&type=script&lang=js&"
export * from "./BugReportDialogue.vue?vue&type=script&lang=js&"
import style0 from "./BugReportDialogue.vue?vue&type=style&index=0&id=d2ec68c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ec68c8",
  null
  
)

export default component.exports